// extracted by mini-css-extract-plugin
export default {"root":"HwQTCXT4","main":"yd9ko5aC","clock":"tRgNrPnn","title":"-YxBbkr-","time":"qEIPCGnd","hand":"OsYmKBC8","isHour":"xEa9qWZJ","extraInfo":"oP0i8n+z"};